export default "__VITE_ASSET__BbvCU62N__"